import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const toastConfig = {
	position: 'top-right' as const,
	autoClose: 10000,
	hideProgressBar: false,
	newestOnTop: true,
	closeOnClick: true,
	rtl: false,
	pauseOnFocusLoss: true,
	draggable: true,
	pauseOnHover: true,
	theme: 'light' as const
}

export const ToastProvider = () => <ToastContainer {...toastConfig} />
